<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
    extends: Line,
    // mixins: [reactiveProp],
    props: ["chartData", "valuationCurrencyPrefix"],
    data(instance) {
        var self = this;
        return {
            options: {
                elements: {
                    line: {
                        tension: 0.4,
                        borderWidth: 1,
                        borderColor: "rgba(127, 210, 232, 0.55)",
                        fill: false,
                    },
                    point: {
                        pointStyle: "rect",
                        backgroundColor: "#7fd2e8",
                        borderWidth: 2,
                        borderColor: "#7fd2e8",
                        hitRadius: 5,
                        hoverRadius: 5,
                    },
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: false,
                                // suggestedMin: 50,
                                //suggestedMax: 100,
                                maxTicksLimit: 10,
                                callback: function (value, index, values) {
                                    return self.$fabHelper.makeMoney(
                                        value,
                                        instance.valuationCurrencyPrefix,
                                        false
                                    );
                                    //return value;
                                },
                            },
                            gridLines: {
                                display: true,
                                lineWidth: 0.5,
                                color: "rgba(0,0,0, 0.15)",
                            },
                            scaleLabel: {
                                color: "rgba(127, 210, 232, 1)",
                                display: true,
                                /*labelString:
                                    "Value (" +
                                    instance.valuationCurrencyPrefix +
                                    ")",*/
                            },
                        },
                    ],

                    xAxes: [
                        {
                            gridLines: {
                                display: true,
                                lineWidth: 0.5,
                                color: "rgba(0,0,0, 0.15)",
                            },
                            scaleLabel: {
                                color: "rgba(127, 210, 232, 1)",
                                display: true,
                                labelString: "Date",
                            },
                            ticks: {
                                autoSkip: true,
                                maxTicksLimit: 24,
                                maxRotation: 45,
                                minRotation: 45,
                            },
                        },
                    ],
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    enabled: true,
                    caretPadding: 6,
                    cornerRadius: 2,
                    titleSpacing: 4,
                    displayColors: false,
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return (
                                instance.valuationCurrencyPrefix +
                                Number(tooltipItem.yLabel)
                                    .toFixed(0)
                                    .replace(/./g, function (c, i, a) {
                                        return i > 0 &&
                                            c !== "." &&
                                            (a.length - i) % 3 === 0
                                            ? "," + c
                                            : c;
                                    })
                            );
                        },
                    },
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                    },
                },
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 1000,
                    // easing: 'easeInSine'
                },
            },
            datasetOptions: {},
        };
    },
    mounted() {
        this.renderLineChart();
        this.$EventBus.$on("valuation-update", (res) => {
            //this.$data._chart.destroy();//this already happens in renderChart()
            this.renderLineChart();
        });
    },
    methods: {
        renderLineChart: function () {
            //get the max & min values from the dataset & update the yAxes min/max
            this.options.scales.yAxes[0].ticks.suggestedMax =
                this.chartData.datasets[0].timeseries_data_max;
            this.options.scales.yAxes[0].ticks.suggestedMin =
                this.chartData.datasets[0].timeseries_data_min;
            this.options.scales.yAxes[0].scaleLabel.labelString =
                "Value (" + this.chartData.valuationCurrencyPrefix + ")";

            this.renderChart(this.chartData, this.options);
        },
    },
    watch: {
        chartData(to, from) {
            console.log("watcher called");

            //this.$data._chart.update();
            // this.$data._chart.destroy();
            // this.renderChart(this.chartData, this.options);
        },
    },

    computed: {
        currencyPrefix: function () {
            return this.chartData.valuationCurrencyPrefix;
        },
    },
};
</script>
